import React, { useContext } from "react";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/GlobalContextProvider";

const Header = () => {
  const dispatch = useContext(GlobalDispatchContext);
  const state = useContext(GlobalStateContext);

  const headerQuery = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 220, height: 50) {
            ...GatsbyImageSharpFixed_withWebp_tracedSVG
          }
        }
      }
    }
  `);
  return (
    <div className="bg-teal-400 shadow-md">
      <div className="container mx-auto px-2">
        <div className="flex items-center justify-between h-16 ">
          <div>
            <Link to="/" className="" activeClassName="">
              <Img
                fixed={headerQuery.file.childImageSharp.fixed}
                alt="Logo de Ekobé"
                title="Logo de Ekobé"
              />
            </Link>
          </div>

          <div className="flex text-white text-lg hidden md:block">
            <Link to="/" className="mr-4" activeClassName="mr-4 font-bold">
              Início
            </Link>
            <Link
              to="/produtos"
              className="mr-4"
              activeClassName="mr-4 font-bold"
            >
              Produtos
            </Link>
            <a
              role="button"
              href="https://vivaemequilibrio.ekobe.ind.br/"
              className="mr-4"
              rel="noopener noreferrer"
              target="_blank"
            >
              Blog
            </a>
            <a
              role="button"
              href="https://www.ekobe.ind.br/sobre-a-ekobe/"
              className="mr-4"
              rel="noopener noreferrer"
              target="_blank"
            >
              Sobre
            </a>
          </div>
          <button
            className="text-white text-2xl md:hidden cursor-pointer"
            onClick={() => dispatch({ type: "TOGGLE_DRAWER" })}
            onKeyDown={(e) =>
              e.key === 13 ? dispatch({ type: "TOGGLE_DRAWER" }) : null
            }
          >
            {state.isDrawerOpen ? (
              <AiOutlineClose></AiOutlineClose>
            ) : (
              <AiOutlineMenu></AiOutlineMenu>
            )}
          </button>
          {/* <pre className="text-white text-xl">{JSON.stringify(state)}</pre> */}
        </div>
      </div>
      {state.isDrawerOpen && (
        <div className="bg-teal-600 text-white text-lg md:hidden text-center py-2">
          <Link
            to="/"
            className="block py-1"
            activeClassName="block py-1 font-bold"
          >
            Início
          </Link>
          <Link
            to="/produtos"
            className="block py-1"
            activeClassName="block py-1 font-bold"
          >
            Produtos
          </Link>
          <a
            role="button"
            href="https://vivaemequilibrio.ekobe.ind.br/"
            className="block py-1"
            rel="noopener noreferrer"
            target="_blank"
          >
            Blog
          </a>
          <a
            role="button"
            href="https://www.ekobe.ind.br/sobre-a-ekobe/"
            className="block py-1"
            rel="noopener noreferrer"
            target="_blank"
          >
            Sobre
          </a>
        </div>
      )}
    </div>
  );
};

export default Header;
